var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/home' }}},[_vm._v("首页")]),_c('el-breadcrumb-item',{staticClass:"test"},[_vm._v("旗下品牌设置")])],1),_c('el-card',[_c('el-tag',{attrs:{"type":"danger"}},[_vm._v("旗下品牌页面如需修改，请联系前端修改")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }